import React, { useState } from 'react';
import ISO3166 from 'iso-3166-1';
import DropdownSelect, { ISelectOption } from '../forms/DropdownSelect/DropdownSelect';

interface Country {
  alpha2: string;
  country: string;
}

interface CountrySelectProps {
  defaultCountryCode?: string;
  onCountryChange: (countryCode: string) => void;
}

const CountrySelect: React.FC<CountrySelectProps> = ({ defaultCountryCode, onCountryChange }) => {
  const countries: Country[] = ISO3166.all();

  const getDefaultCountry = (code: string | undefined): ISelectOption | null => {
    if (!code) return null;
    const country = countries.find(c => c.alpha2 === code);
    return country ? { label: country.country, value: code } : null;
  };
  
  const [selectedCountry, setSelectedCountry] = useState<ISelectOption | null>(
    getDefaultCountry(defaultCountryCode)
  );

  const handleChange = (option: ISelectOption | null) => {
    setSelectedCountry(option);
    if (option) {
      onCountryChange(option.value);
    }
  };

  return (
    <DropdownSelect
      label="Select country or region"
      value={selectedCountry}
      options={countries.map((country) => ({ label: country.country, value: country.alpha2 }))}
      onChange={handleChange}
      isSearchable={true}
      blurInputOnSelect
      withDescription
      placeholder="Select country"
    />
  );
};

export default CountrySelect;
